import React from "react";
import { PieChart, Pie, Cell, ResponsiveContainer, Legend } from "recharts";
// import "./MetricsDashboard.css";

const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042", "#8884D8", "#82CA9D"];

const MetricsDashboard = ({ payload }) => {
  const { userMetrics, quizMetrics, browserMetrics } = payload;

  // Prepare data for pie charts
  const userParticipationData = [
    { name: "Participants", value: userMetrics[1].value },
    { name: "Non-Participants", value: userMetrics[0].value - userMetrics[1].value }
  ];

  const quizCompletionData = [
    { name: `Completed(${userMetrics[4].value}) ` , value: userMetrics[4].value },
    { name: `Started(${userMetrics[1].value})`, value: userMetrics[1].value }
  ];

  return (
    <div className="dashboard-container1">
      {/* <h2 className="dashboard-title">User Engagement Analytics</h2> */}
      
      {/* User Metrics Section */}
      <div className="metrics-section">
        <h3>User Metrics</h3>
        <div className="metrics-grid">
          {/* Total Registration Card */}
          {/* <div> */}
          <MetricCard 
            metric={userMetrics[0]}
            isProgress={false}
          />
          
          {/* Total Participants Card */}
          <MetricCard 
            metric={userMetrics[1]} 
            isProgress={false}
          />

          <MetricCard 
            metric={userMetrics[2]}
            isProgress={false}
            // maxValue={100}
          />
           <MetricCard 
            metric={userMetrics[3]}
            isProgress={true}
            maxValue={100}
          />
          {/* </div> */}
          </div>
        <div className="metrics-grid metrics-grid-col-2">

          {/* Pie Chart - User Participation */}
          <div className="chart-card">
            <h4>User Participation</h4>
            <div className="chart-container">
              <ResponsiveContainer width="100%" height={200}>
                <PieChart>
                  <Pie
                    data={userParticipationData}
                    cx="50%"
                    cy="50%"
                    outerRadius={80}
                    fill="#8884d8"
                    dataKey="value"
                    label={({ name, percent }) => `${name}: ${(percent * 100)?.toFixed(1)}%`}
                  >
                    {userParticipationData.map((entry, index) => (
                      <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                    ))}
                  </Pie>
                  <Legend style={{marginTop:"1000px"}} />
                </PieChart>
              </ResponsiveContainer>
            </div>
          </div>
          
          {/* Returning Users Metrics */}
         
          
         
          
          {/* <MetricCard 
            metric={userMetrics[4]}
            isProgress={true}
            maxValue={100}
          /> */}
          
          {/* Pie Chart - Returning Users */}
          <div className="chart-card">
            <h4>Quiz Completion Rate</h4>
            <div className="chart-container">
              <ResponsiveContainer width="100%" height={200}>
                <PieChart>
                  <Pie
                    data={quizCompletionData}
                    cx="50%"
                    cy="50%"
                    innerRadius={60}
                    outerRadius={80}
                    fill="#8884d8"
                    dataKey="value"
                    label={({ name, percent }) => `${name}: ${(percent * 100)?.toFixed(1)}%`}
                  >
                    {quizCompletionData.map((entry, index) => (
                      <Cell key={`cell-${index}`} fill={COLORS[(index + 2) % COLORS.length]} />
                    ))}
                  </Pie>
                  <Legend />
                </PieChart>
              </ResponsiveContainer>
            </div>
          </div>
        </div>
      </div>

      
      {/* Browser Metrics Section */}
      <div className="metrics-section">
        <h3>Browser Metrics</h3>
        <div className="metrics-grid metrics-grid-col-3">
          {browserMetrics.map((metric, index) => (
            <MetricCard 
              key={`quiz-${index}`}
              metric={metric}
            />
          ))}
        </div>
      </div>
      
      {/* Quiz Metrics Section */}
      <div className="metrics-section">
        <h3>Quiz Metrics</h3>
        <div className="metrics-grid">
          {quizMetrics.map((metric, index) => (
            index < 4 && <MetricCard 
              key={`quiz-${index}`}
              metric={metric}
              isProgress={index === 2 || index === 3} // Only show progress for completion rate
              maxValue={index === 2 ? quizMetrics[4].value : index === 3 ? quizMetrics[4].value/quizMetrics[0].value:null}
            />
          ))}
        </div>
      </div>

    </div>
  );
};

const MetricCard = ({ metric, isProgress, maxValue }) => {
  return (
    <div className="metric-card">
      <div className="metric-header">
        <h4>{metric.label}</h4>
        <span className="metric-tooltip" title={metric.detail}>ℹ️</span>
      </div>
      <div className="metric-value">
        {typeof metric.value === 'number' 
          ? metric.value % 1 === 0 
            ? metric.value.toLocaleString() 
            : metric.value?.toFixed(2)
          : metric.value}
        {metric.label.includes("%") && !isProgress ? "%" : ""}
      </div>
      {isProgress && (
        <div className="progress-container">
          <div 
            className="progress-bar" 
            style={{ width: `${(metric.value / maxValue) * 100}%` }}
          ></div>
          <span className="progress-label">{((metric.value / maxValue) * 100)?.toFixed(2)}%</span>
        </div>
      )}
    </div>
  );
};

export default MetricsDashboard;